module.exports = __webpack_public_path__ + "img/hover_icon_eden_configuration.a769f5e3.svg";